<template>
  <div class="button-wrapper">
    <v-btn
      min-width="120"
      variant="outlined"
      data-testid="cancel-filter-spec"
      @click="$emit('close-filter-specification')"
    >
      Cancel
    </v-btn>
    <np-action-btn
      min-width="120"
      data-testid="apply-filter-spec"
      @click="$emit('apply-filters')"
    >
      Apply
    </np-action-btn>
  </div>
</template>

<script lang="ts">
export default {
  name: 'FilterSpecButtons',
  emits: ['close-filter-specification', 'apply-filters'],
};
</script>

<style scoped lang="scss">
.button-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  :deep(.v-btn) {
    margin-right: 0px;
  }
}
</style>
